import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-FlagThailand-taiguo",
  "use": "icon-FlagThailand-taiguo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-FlagThailand-taiguo\"><defs><style type=\"text/css\"></style></defs><path d=\"M23.272727 132.654545h977.454546v651.636364H23.272727z\" fill=\"#BE352C\" p-id=\"3550\" /><path d=\"M23.272727 239.709091h977.454546v437.527273H23.272727z\" fill=\"#FFFFFF\" p-id=\"3551\" /><path d=\"M23.272727 351.418182h977.454546v211.781818H23.272727z\" fill=\"#083F80\" p-id=\"3552\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol